import { render, staticRenderFns } from "./JustARouter.vue?vue&type=template&id=8e5641f6&lang=pug&"
import script from "./JustARouter.vue?vue&type=script&lang=ts&"
export * from "./JustARouter.vue?vue&type=script&lang=ts&"
import style0 from "./JustARouter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports